import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Property, PropertyCreate, PropertyUpdate } from '../types/api.types'

export const platformPropertiesService = {
  async getByOrg(orgId: number, propertyType?: string): Promise<Property[]> {
    const qs = propertyType ? `?property_type=${encodeURIComponent(propertyType)}` : ''
    const { data } = await axiosInstance.get<Property[]>(`${API_ENDPOINTS.PLATFORM_ORG_PROPERTIES(orgId)}${qs}`)
    return data
  },

  async create(orgId: number, payload: PropertyCreate): Promise<Property> {
    const { data } = await axiosInstance.post<Property>(
      API_ENDPOINTS.PLATFORM_ORG_PROPERTIES(orgId),
      payload,
    )
    return data
  },

  async update(orgId: number, propId: number, payload: PropertyUpdate): Promise<Property> {
    const { data } = await axiosInstance.put<Property>(
      API_ENDPOINTS.PLATFORM_ORG_PROPERTY(orgId, propId),
      payload,
    )
    return data
  },

  async delete(orgId: number, propId: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.PLATFORM_ORG_PROPERTY(orgId, propId))
  },
}
